import Http, * as Endpoint from "../Http";
import * as action from "../store/actions";
import { errorsTransformer } from "../Http";

/**
 * Send prove of payment form
 *
 * @param payload
 * @returns {function(*): Promise<any>}
 */
export const sendPaymentProve = payload => {
  return sendMail(Endpoint.SEND_PROVE_OF_PAYMENT, payload);
};

/**
 * Send contact request form
 *
 * @param payload
 * @returns {function(*): Promise<any>}
 */
export const sendContactRequest = payload => {
  return sendMail(Endpoint.SEND_CONTACT_REQUEST, payload);
};

/**
 * Toggles whether the use receives payment plan emails
 *
 * @param payload boolean
 * @returns {function(*=): Promise<unknown>}
 */
export const toggleMailSubscription = payload => {
  return dispatch => {
    dispatch(action.setIsSubscribed(payload));

    return new Promise((resolve, reject) =>
      Http.post(Endpoint.TOGGLE_MAIL_SUBSCRIPTION, {
        is_subscribed: payload,
      })
        .then(resolve)
        .catch(e => {
          dispatch(action.setIsSubscribed(!payload));
          reject(errorsTransformer(e));
        })
    );
  };
};

/**
 * Send an email
 *
 * @param endpoint
 * @param payload
 *
 */
const sendMail = (endpoint, payload) => {
  return new Promise((resolve, reject) => {
    Http.post(endpoint, payload)
      .then(res => {
        resolve();
      })
      .catch(err => {
        reject(errorsTransformer(err));
      });
  });
};
